import React, { ReactNode } from 'react';
import { Box, Flex, VStack } from '@chakra-ui/react';

interface Props {
  aboveForm?: ReactNode;
  belowForm?: ReactNode;
  form?: ReactNode;
  formImage?: ReactNode;
}

const FormWrapper: React.FC<Props> = ({
  aboveForm,
  form,
  belowForm,
  formImage,
}: Props) => {
  return (
    <VStack d="block" w={['100%', '450px']} mt={[0, '-100px']} spacing={8}>
      <Box p={[4, 0]}>{aboveForm}</Box>
      <Box
        borderRadius="2xl"
        position="relative"
        bg="gray.800"
        padding={8}
        paddingBottom={formImage ? '165px' : 8}
        boxShadow="0px 4px 13px 2px rgba(0, 0, 0, 0.25)"
      >
        {form}
        {formImage && (
          <Box
            bottom="0"
            position={['relative', 'absolute']}
            mt={6}
            w={['100%', '575px']}
            ml={['0', '-100px']}
            mb="-150px"
          >
            {formImage}
          </Box>
        )}
      </Box>
      {belowForm}
    </VStack>
  );
};

export default FormWrapper;
